import { Box, TextField } from "@mui/material";
import React, { useEffect } from "react";

interface FormProps {
  data: Record<string, any>;
  updateData: (data: Record<string, any>) => void;
  validateForm: (isValid: boolean) => void;
}

export default function FirstForm({ data, updateData, validateForm }: FormProps) {
  const [nombre, setNombre] = React.useState(data.nombre || '');
  const [lastname1, setLastname1] = React.useState(data.lastname1 || '');
  const [lastname2, setLastname2] = React.useState(data.lastname2 || '');

  useEffect(() => {
    validateForm(nombre !== '' && lastname1 !== '' && lastname2 !== '');
  }, [nombre, lastname1, lastname2, validateForm]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'nombre') {
      setNombre(value);
    } else if (name === 'lastname1') {
      setLastname1(value);
    } else if (name === 'lastname2') {
      setLastname2(value);
    }
    updateData({ [name]: value });
  };

  return (
    <Box component="form" sx={{ mt: 2, width:{xs:'100%',md:'500px'}, maxWidth: 500}}> {/* Ajuste el ancho aquí */}
      <TextField
        label="Nombre"
        name="nombre"
        value={nombre}
        onChange={handleChange}
        sx={{ mb: 2, '& .MuiInputBase-root': { height: 50 }, width: '100%' }}  // 100% de ancho en móvil
      />
      <TextField
        label="Primer Apellido"
        name="lastname1"
        value={lastname1}
        onChange={handleChange}
        sx={{ mb: 2, '& .MuiInputBase-root': { height: 50 }, width: '100%' }}  // 100% de ancho en móvil
      />
      <TextField
        label="Segundo Apellido"
        name="lastname2"
        value={lastname2}
        onChange={handleChange}
        sx={{ '& .MuiInputBase-root': { height: 50 }, width: '100%' }} // 100% de ancho en móvil
      />
    </Box>
  );
}
